"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _fr = _interopRequireDefault(require("react-intl/locale-data/fr"));
var _en = _interopRequireDefault(require("react-intl/locale-data/en"));
var _de = _interopRequireDefault(require("react-intl/locale-data/de"));
var _es = _interopRequireDefault(require("react-intl/locale-data/es"));
var _enUS = _interopRequireDefault(require("../../../../intl-web-templates/compiled/en-US.json"));
var _frFR = _interopRequireDefault(require("../../../../intl-web-templates/compiled/fr-FR.json"));
var _enGB = _interopRequireDefault(require("../../../../intl-web-templates/compiled/en-GB.json"));
var _deDE = _interopRequireDefault(require("../../../../intl-web-templates/compiled/de-DE.json"));
var _esES = _interopRequireDefault(require("../../../../intl-web-templates/compiled/es-ES.json"));
var _frFR2 = _interopRequireDefault(require("../intl-shared-component/compiled/fr-FR.json"));
var _enUS2 = _interopRequireDefault(require("../intl-shared-component/compiled/en-US.json"));
var _enGB2 = _interopRequireDefault(require("../intl-shared-component/compiled/en-GB.json"));
var _deDE2 = _interopRequireDefault(require("../intl-shared-component/compiled/de-DE.json"));
var _esES2 = _interopRequireDefault(require("../intl-shared-component/compiled/es-ES.json"));
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en.default), _toConsumableArray(_fr.default), _toConsumableArray(_de.default), _toConsumableArray(_es.default))); // react-intl v2 only
// imports below are from the services using them. Each service has an alias mapping intl-web to the respective intl-web-* repo i.e intl-web-templates, intl-web-search, etc.

var loadTranslationData = function loadTranslationData(translationLocale) {
  var lowercaseLocale = translationLocale.toLowerCase();
  switch (lowercaseLocale) {
    case 'fr-fr':
    case 'fr':
      return _objectSpread(_objectSpread({}, _frFR.default), _frFR2.default);
    case 'en-gb':
      return _objectSpread(_objectSpread({}, _enGB.default), _enGB2.default);
    case 'de-de':
      return _objectSpread(_objectSpread({}, _deDE.default), _deDE2.default);
    case 'es-es':
      return _objectSpread(_objectSpread({}, _esES.default), _esES2.default);
    default:
      return _objectSpread(_objectSpread({}, _enUS.default), _enUS2.default);
  }
};
var SharedIntlProviderHOC = exports.default = /*#__PURE__*/function (_React$Component) {
  _inherits(SharedIntlProviderHOC, _React$Component);
  function SharedIntlProviderHOC(props) {
    var _this;
    _classCallCheck(this, SharedIntlProviderHOC);
    _this = _callSuper(this, SharedIntlProviderHOC, [props]);
    // This is to account for the components that use its own locale like locale of space or booking
    var locale = _this.props.locale || SharedIntlProviderHOC.getLocale();
    _this.state = {
      messages: _this.getMessages(),
      locale: locale
    };
    return _this;
  }
  _createClass(SharedIntlProviderHOC, [{
    key: "getMessages",
    value: function getMessages() {
      var locale = this.props.locale || SharedIntlProviderHOC.getLocale();
      var envLocaleData = this.props.envLocaleData || SharedIntlProviderHOC.getEnvLocaleData();
      // iosLocale is passed as a prop from profile for iOS webview
      var translationLocale = (0, _get.default)(envLocaleData, "".concat(locale, ".translations"), '') || this.props.iosLocale || '';
      return loadTranslationData(translationLocale);
    }
  }, {
    key: "render",
    value: function render() {
      // iosLocale is passed as a prop from profile for iOS webview
      var locale = this.state.locale || this.props.iosLocale;
      return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
        locale: locale || 'en',
        messages: this.state.messages
      }, this.props.children);
    }
  }], [{
    key: "getEnvLocaleData",
    value: function getEnvLocaleData() {
      try {
        if ('undefined' !== typeof document) {
          var trojanElement = document.getElementById('initial-data');
          if (trojanElement) {
            var envLocalMapString = trojanElement.getAttribute('data-locale-data');
            return JSON.parse(envLocalMapString);
          }
        }
      } catch (e) {
        console.warn(e);
      }
      return {};
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      var trojanElement;
      var userLocale = '';
      try {
        if ('undefined' !== typeof document) {
          trojanElement = document.getElementById('initial-data');
          if (trojanElement) {
            userLocale = trojanElement.getAttribute('data-user-locale');
          }
        }
      } catch (e) {
        console.warn(e);
      }
      var envLocaleData = SharedIntlProviderHOC.getEnvLocaleData() || {};
      return envLocaleData[userLocale] && userLocale || 'en-US';
    }
  }, {
    key: "getUrlPrefix",
    value: function getUrlPrefix() {
      var locale = SharedIntlProviderHOC.getLocale();
      var envLocaleData = SharedIntlProviderHOC.getEnvLocaleData();
      var urlPrefix = (0, _get.default)(envLocaleData, "".concat(locale, ".url_prefix"), '');
      return urlPrefix;
    }
  }, {
    key: "getTranslations",
    value: function getTranslations() {
      var locale = SharedIntlProviderHOC.getLocale();
      var envLocaleData = SharedIntlProviderHOC.getEnvLocaleData();
      var translations = (0, _get.default)(envLocaleData, "".concat(locale, ".translations"), 'en-US');
      return translations;
    }
  }, {
    key: "getZendeskLocale",
    value: function getZendeskLocale() {
      var locale = SharedIntlProviderHOC.getLocale();
      var envLocaleData = SharedIntlProviderHOC.getEnvLocaleData();
      var zenDeskLocale = (0, _get.default)(envLocaleData, "".concat(locale, ".zendesk_url_locale"), 'en-us');
      return zenDeskLocale;
    }
  }]);
  return SharedIntlProviderHOC;
}(_react.default.Component);
SharedIntlProviderHOC.propTypes = {
  locale: _propTypes.default.string,
  envLocaleData: _propTypes.default.object,
  children: _propTypes.default.object
};